import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import About from "./pages/About";
import Service from "./pages/Service";
import Team from "./pages/Team";
import Client from "./pages/Client";
import Contact from "./pages/Contact";

function App() {
  const location = useLocation();

  // cek apakah halaman Home
  const isHome = location.pathname === "/";

  // scroll ke atas setiap pindah halaman
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // bisa diganti "auto" kalau mau langsung tanpa animasi
    });
  }, [location.pathname]);

  return (
  <div className="overflow-x-hidden w-full">
    <Navbar />
    <div className={isHome ? "" : "pt-24"}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/team" element={<Team />} />
        <Route path="/client" element={<Client />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
    <Footer />
  </div>
  );
}

export default App;
